<template>
  <div class="bootstrap">
    <div class="row m-4" v-if="!sended">
      <div class="col">
        <p>&nbsp;</p>
        <div class="text-danger" v-if="errorMessage">{{ errorMessage }}</div>
        <input type="text" class="form-control" v-model="fio" placeholder="Ваше имя..."/>
        <input type="text" class="form-control" v-model="email" placeholder="Ваш email..."/>
        <textarea class="form-control" v-model="question" placeholder="Ваш вопрос..."></textarea>
        <button class="btn-warning btn btn-block" @click="send()"> Отправить вопрос</button>
      </div>
    </div>
    <div class="row m-4 text-center" v-if="sended">
      <h3>Ваш вопрос успешно отправлен!</h3>
      <h6>В ближайшее время мы вам ответим на почту</h6>
    </div>
  </div>
</template>

<script>
import FaqForm from "@/components/core/FaqForm.vue";

export default {
  name: 'FaqForm',
  components: FaqForm,
  props: [],
  data() {
    return {
      fio: null,
      email: null,
      question: null,
      errorMessage: null,
      sended: false,
    }
  },
  methods: {
    send() {
      if (!this.fio || !this.email || !this.question) {
        this.errorMessage = 'Необходимо заполнить данные';
        return;
      }
      this.$http.post('/index/add-faq/', {
        fio: this.fio,
        email: this.email,
        question: this.question,
        checkString: btoa(new Date().getTime() + 'checked')
      }).then((result) => {
        result
        this.sended = true
      }, (error) => {
        this.errorMessage = error.message
      });

    }
  }
}
</script>

<style scoped>
.bootstrap {
  z-index: 2000;
}

.btn-orange {
  width: 100%;
}

textarea {
  width: 100%;
  height: 400px;
}

</style>
